<template>
  <CustomUpdateDialog
    dialogTitle="تغییر وضعیت اشتراک اکانت کاربر"
    :dialogId="`toggle-user-family-verify-dialog-${
      tempSelectedUserFamily ? tempSelectedUserFamily.familyUserId : ''
    }`"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendToggleVerifyRequest"
    @close="closeToggleUserFamilyVerifyModal"
    ok-title="تایید"
  >
    <p v-if="tempSelectedUserFamily">
      آیا از تغییر وضعیت مشترک
      <span style="font-weight: bold">
        {{ tempSelectedUserFamily.familyUserFullName }}
      </span>
      به
      <span
        style="font-weight: bold"
        :class="
          tempSelectedUserFamily.isVerified ? 'text-danger' : 'text-success'
        "
      >
        {{ tempSelectedUserFamily.isVerified ? "تایید نشده" : "تایید شده" }}
      </span>
      اطمینان دارید؟
    </p>
  </CustomUpdateDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    tempSelectedUserFamily: {
      type: Object,
    },
    selectedUserId: {
      type: [Number, String],
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
      verifyTogglePayload: {
        familyUserId: null,
        userId: null,
      },
    };
  },
  methods: {
    closeToggleUserFamilyVerifyModal() {
      this.$bvModal.hide(
        `toggle-user-family-verify-dialog-${
          this.tempSelectedUserFamily
            ? this.tempSelectedUserFamily.familyUserId
            : ""
        }`
      );
    },
    async sendToggleVerifyRequest() {
      try {
        this.verifyTogglePayload.familyUserId =
          this.tempSelectedUserFamily.familyUserId;
        this.verifyTogglePayload.userId = this.selectedUserId;
        this.isOkButtonDisabled = true;
        let _this = this;
        let toggleVerifyUserFamily = new ToggleVerifyUserFamily(_this);
        toggleVerifyUserFamily.setRequestParam(this.verifyTogglePayload);
        await toggleVerifyUserFamily.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "تغییر کرد!",
                icon: "CheckIcon",
                variant: "success",
                text: "وضعیت مشترک با موفقیت تغییر کرد.",
              },
            });
            _this.$emit("refetch");
            _this.verifyTogglePayload = {
              familyUserId: null,
              userId: null,
            };
            _this.closeToggleUserFamilyVerifyModal();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "تغییر نکرد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomUpdateDialog,
  },
};
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import { ToggleVerifyUserFamily } from "@/libs/Api/Users";
</script>
